import { isTag } from 'anodum';
import findRootEditableElement from './find-root-editable-element';
import isEmptyEditableElement from '../verifiers/is-empty-editable-element';
import findNextNode from './find-next-node';
import setCaretAtTheBeginningOfNode from './set-caret-at-the-beginning-of-node';
import getCollapsedNodeAndOffset from './get-collapsed-node-and-offset';
import { findPrevEditableElement } from './find-editable-element';
import getElementFromNode from './get-element-from-node';
import { LIST_ELEMENTS, LIST_ITEM } from '../constants/editable-elements';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';

const handleFirstEmptyElement = (e) => {
  const [node, offset] = getCollapsedNodeAndOffset();
  const anchorElement = getElementFromNode(node);
  if (!anchorElement) return false;

  const rootNode = anchorElement.closest('[contenteditable]');
  const prevEditableElement = findPrevEditableElement(node);

  if (prevEditableElement || offset) return false;

  /**
     Native behavior for backspace first empty element in contenteditable works in other way we want.
     First empty editable element should be removed.
     */
  const hasListElements = rootNode.querySelectorAll(LIST_ELEMENTS).length;

  if (
    (!hasListElements && rootNode.childElementCount > 1) ||
    (hasListElements && rootNode.querySelectorAll(LIST_ITEM).length > 1)
  ) {
    /** contenteditable element should always have at list one element */
    const editableElement = findRootEditableElement(node);
    if (!editableElement || !isEmptyEditableElement(editableElement)) return false;
    e.preventDefault();

    const { parentNode } = editableElement;
    const nextNodeForSelection = findNextNode(node, rootNode);

    const isImageNode = Boolean(nextNodeForSelection.closest(IMAGE_SELECTOR));
    if (isImageNode) return false;

    editableElement.remove();
    if (isTag(editableElement, LIST_ITEM) && !parentNode.childElementCount) {
      parentNode.remove();
    }

    setCaretAtTheBeginningOfNode(nextNodeForSelection);

    return true;
  }

  return false;
};

export default handleFirstEmptyElement;
